import React from 'react';
import { Home, MessageCircle, Users, Settings, CalendarDays } from 'lucide-react';

/** 모바일 하단 탭 5종. '캘린더'는 일정(개인·부서·회사), '온라인'은 조직도(접속자) 패널, '설정'은 프로필·안내·도움말·로그아웃 묶음 */
export type MobileTab = 'home' | 'chat' | 'calendar' | 'org' | 'settings';

interface MobileTabBarProps {
  active: MobileTab;
  onChange: (tab: MobileTab) => void;
  unreadTotal: number;
}

const TABS: { key: MobileTab; label: string; icon: React.ElementType }[] = [
  { key: 'home', label: '홈', icon: Home },
  { key: 'chat', label: '대화방', icon: MessageCircle },
  { key: 'calendar', label: '캘린더', icon: CalendarDays },
  { key: 'org', label: '온라인', icon: Users },
  { key: 'settings', label: '설정', icon: Settings },
];

// 모바일 전용 하단 탭바. fixed가 아니라 루트 flex-col의 형제로 배치되어 높이를 레이아웃이 흡수한다
export const MobileTabBar: React.FC<MobileTabBarProps> = ({ active, onChange, unreadTotal }) => (
  <nav className="md:hidden shrink-0 flex border-t border-slate-200 bg-white safe-area-bottom" aria-label="주요 화면">
    {TABS.map(({ key, label, icon: Icon }) => {
      const isActive = active === key;
      const badge = key === 'chat' ? unreadTotal : 0;
      return (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          aria-current={isActive ? 'page' : undefined}
          aria-label={badge > 0 ? `${label}, 안읽음 ${badge}` : label}
          className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] transition-colors ${
            isActive ? 'text-brand-600' : 'text-slate-400 hover:text-slate-600'
          }`}
        >
          <span className="relative">
            <Icon size={22} strokeWidth={isActive ? 2.25 : 2} />
            {badge > 0 && (
              <span className="absolute -top-1.5 -right-2.5 bg-brand-600 text-white text-[10px] font-bold px-1 py-px rounded-full min-w-[16px] text-center leading-tight">
                {badge > 99 ? '99+' : badge}
              </span>
            )}
          </span>
          <span className={`text-[11px] ${isActive ? 'font-bold' : 'font-medium'}`}>{label}</span>
        </button>
      );
    })}
  </nav>
);
